import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { Client } from '../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import {
    ArticleScanAutocompleteComponent,
    ArticleScanSelectedEvent,
} from '../../../components/article-scan-autocomplete/article-scan-autocomplete.component';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Material } from '../../../warehouse/material/material';
import {
    Abgabebeleg,
    AbgabebelegWarenkorb,
} from '../../../../../projects/kiene-core/src/lib/components/abgabebelege/classes/abgabebeleg';

@Component({
    selector: 'kiene-abgabebeleg-warenkorb-dialog',
    templateUrl: './abgabebeleg-warenkorb-dialog.component.html',
    styleUrls: ['./abgabebeleg-warenkorb-dialog.component.scss'],
})
export class AbgabebelegWarenkorbDialogComponent implements OnInit {
    @ViewChild('mengeInput') mengeInput: MatInput;
    @ViewChild('articleScan') articleScan: ArticleScanAutocompleteComponent;

    currentClient: Client;
    mengeCtrl = new UntypedFormControl();
    warenkorbEintraege: AbgabebelegWarenkorb[] = [];
    currentWarenkorbArtikel: Material;
    isSaving = false;
    editAwId: number;

    constructor(
        public dialogRef: MatDialogRef<AbgabebelegWarenkorbDialogComponent>,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private localStorageService: LocalStorageService,
        private tableService: KieneTableService,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {
        this.currentClient = this.localStorageService.getCurrentClient();
        this.loadAbgabebelegWarenkorb();
    }

    loadAbgabebelegWarenkorb() {
        let params = new HttpParams();
        if (this.currentClient.unternehmensgruppe_id) {
            params = params.set('unternehmensgruppe_id', this.currentClient.unternehmensgruppe_id.toString());
        } else {
            params = params.set('kunde_id', this.currentClient.kunde_id.toString());
        }
        this.tableService.get(this.apiBaseUrl + 'abgabebeleg_warenkorb/read.php', params).subscribe({
            next: response => {
                this.warenkorbEintraege = response.records;
                this.articleScan?.setFocus();
            },
            error: err => {
                this.messageService.errorMessage('Warenkorb konnte nicht geladen werden!', err);
            },
        });
    }

    setWarenkorbArtikel(event: ArticleScanSelectedEvent) {
        this.currentWarenkorbArtikel = event.article;
        this.mengeInput?.focus();
    }

    addArtikelWarenkorb() {
        if (!this.currentWarenkorbArtikel?.artikel_id || !this.mengeCtrl.value) {
            return;
        }

        const aw = new AbgabebelegWarenkorb();
        if (this.editAwId) {
            aw.aw_id = this.editAwId;
        }
        aw.artikel_id = this.currentWarenkorbArtikel.artikel_id;
        aw.artikelmenge = this.mengeCtrl.value;
        aw.kunde_id = this.currentClient.kunde_id;
        this.updateAbgabebelegWarenkorb(aw);
    }

    private updateAbgabebelegWarenkorb(aw: AbgabebelegWarenkorb): void {
        this.isSaving = true;
        this.tableService.updateEntity(this.apiBaseUrl + 'abgabebeleg_warenkorb/update.php', aw).subscribe({
            next: () => {
                this.articleScan.clearAndFocus();
                this.mengeCtrl.setValue(null);
                this.loadAbgabebelegWarenkorb();
                this.messageService.infoMessage('Die Position wurde erfolgreich hinzugefügt!');
                this.isSaving = false;
                this.editAwId = null;
            },
            error: err => {
                this.messageService.errorMessage('Eintrag konnte nicht hinzugefügt werden!', err);
                this.isSaving = false;
            },
        });
    }

    deleteItem(we: AbgabebelegWarenkorb) {
        const index = this.warenkorbEintraege.indexOf(we);
        this.warenkorbEintraege.splice(index, 1);
        this.tableService.deleteEntity(this.apiBaseUrl + 'abgabebeleg_warenkorb/delete.php', we).subscribe({
            next: () => {
                this.loadAbgabebelegWarenkorb();
                this.messageService.infoMessage('Das Element wurde erfolgreich gelöscht!');
            },
            error: err => {
                this.messageService.errorMessage('Das Element konnte nicht gelöscht werden!', err);
                this.loadAbgabebelegWarenkorb();
            },
        });
    }

    close() {
        this.dialogRef.close();
    }

    abgabebelegErzeugen() {
        this.tableService
            .post(
                this.apiBaseUrl + 'abgabebeleg/generieren_warenkorb.php',
                { kunde_id: this.currentClient.kunde_id },
                undefined,
            )
            .subscribe({
                next: (response: Abgabebeleg) => {
                    this.messageService.infoMessage('Der Abgabebeleg wurde erfolgreich erstellt!');
                    this.dialogRef.close(response);
                },
                error: err => {
                    this.messageService.errorMessage('Der Abgabebeleg konnte nicht erstellt werden!', err);
                },
            });
    }

    blurMenge() {
        this.addArtikelWarenkorb();
    }

    public editWarenkorbEintrag(we: AbgabebelegWarenkorb): void {
        this.mengeCtrl.setValue(we.artikelmenge);
        this.articleScan.articleInput.value = we.artikel_me;
        if (!this.currentWarenkorbArtikel) {
            this.currentWarenkorbArtikel = new Material();
        }
        this.currentWarenkorbArtikel.artikel_id = we.artikel_id;
        this.editAwId = we.aw_id;
        this.mengeInput?.focus();
    }
}
